import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-create-fleet-and-user',
  templateUrl: './create-fleet-and-user.component.html',
  styleUrls: ['./create-fleet-and-user.component.scss']
})
export class CreateFleetAndUserComponent implements OnInit {

  @Input()
  titles;

  @Input()
  user;

  @Input()
  fleet;

  @Output()
    saveFleetAndUser = new EventEmitter();

  captchaValid = false;

  username_check = '';

  constructor() { }

  ngOnInit() {
  }

  compareFn(t1,t2):boolean {
    return t1.id ===t2.id;
  }

  handleCorrectCaptcha($event) {
    this.captchaValid = true;
  }

  onSubmit(formValues) {
    this.saveFleetAndUser.emit(formValues);
  }

}
